import React from 'react'

import { FormattedMessage } from 'react-intl'

import FlatButton from '@components/UI/FlatButton'
import Theme from '@theme'
import { Header } from '@tribegroup'
import { IButtonProps } from './Button'
import BrandedContentAdBarButtonWrapper from './Wrapper'

const RightsAccepted: React.FC<IButtonProps> = ({ onClick, submissionId }) => (
  <BrandedContentAdBarButtonWrapper submissionId={submissionId}>
    <FlatButton backgroundColor={Theme.primary100Color} onClick={onClick}>
      <Header color={Theme.defaultColor} uppercase cta>
        <FormattedMessage id="submission.bca.rights.accepted" />
      </Header>
    </FlatButton>
  </BrandedContentAdBarButtonWrapper>
)

export { RightsAccepted }
export default RightsAccepted
